import axios from "axios";
import { BaseStudioApi } from "../BaseStudioApi";

export class Base2DApi extends BaseStudioApi {
  constructor() {
    super();

    const token = process.env.REACT_APP_TOKEN_STUDIO_API || "";

    this.axiosInstance = axios.create({
      baseURL: BaseStudioApi.getBaseURL(),
      headers: {
        Authorization: token,
        Accept: "application/json",
      },
      responseType: "json",
    });
  }
}
